/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import FileLoader = alm.io.FileLoader;
	import EventDispatcher = alm.event.EventDispatcher;
	import IFileHandler = alm.io.IFileHandler;
	import QueryString = alm.browser.QueryString;
	import FileLoaderErrorEvent = alm.io.FileLoaderErrorEvent;
	import FileLoaderSuccessEvent = alm.io.FileLoaderSuccessEvent;

	export class AssetLoader extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super();

			this.isLocalhost = window.location.href.indexOf('local') != -1;

			this.baseUrl = Config.useDevServer ? 'https://api-dev.yamap.com/' : 'https://api.yamap.com/';
			trace('[AssetLoader] bas url :', this.baseUrl);
			trace('[AssetLoader] is localhost :', this.isLocalhost);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public load():void {
			const query = new QueryString(window.location.href);

			this.activityId = query.getString('activity_id', '');
			this.token = query.getString('yamap_token', Cookies.get(Config.useDevServer ? 'yamap_token_dev' : 'yamap_token'));

			this.requestHeaders = { 'Authorization': 'Token token=' + this.token, 'X-Yamap-Family': '3DMAP/1.0.0' };

			trace('[AssetLoader] load : activity id =', this.activityId, ', token =' , this.token);
			this.loadMeta();
		}





		private loadMeta():void {
			this.loadData(
				this.baseUrl + 'activities/' + this.activityId + '/three_dimension_map_meta',
				new JsonFileHandler(this.requestHeaders),
				AssetLoaderEvent.META,
				(data:any):boolean => {
					this.meta = new Meta(data);
					if (this.meta.getIsAvailable()) {
						this.loadDem();
						return true;
					} else {
						return false;
					}
				});
		}

		private loadDem():void {
			let url = this.meta.getDemUrl();
			this.loadData(
				url,
				new TextFileHandler(this.requestHeaders),
				AssetLoaderEvent.DEM,
				(data:any):boolean => {
					this.dem = new Dem(data);
					if (this.dem.getIsAvailable()) {
						this.loadActivity();
						return true;
					} else {
						return false;
					}
				});
		}

		private loadActivity():void {
			this.loadData(
				this.baseUrl + 'activities/' + this.activityId + '.json',
				new JsonFileHandler(this.requestHeaders),
				AssetLoaderEvent.ACTIVITY,
				(data:any):boolean => {
					this.activity = new Activity(data);
					if (this.activity.getIsAvailable()) {
						this.loadTrack();
						return true;
					} else {
						return false;
					}
				});
		}

		private loadTrack():void {
			this.loadData(
				this.baseUrl + 'activities/' + this.activityId + '/tracks.json',
				new JsonFileHandler(this.requestHeaders),
				AssetLoaderEvent.TRACK,
				(data:any):boolean => {
					this.track = new Track(data);
					if (this.track.getIsAvailable()) {
						this.loadColorMapElevation();
						return true;
					} else {
						return false;
					}
				});
		}

		private loadColorMapElevation():void {
			this.loadData(
				'image/color-map-elevation.png',
				new ImageFileHandler(),
				AssetLoaderEvent.COLOR_MAP_ELEVATION,
				(data:any):boolean => {
					this.colorMapElevation = new ColorMap();
					this.colorMapElevation.set(data, 1024, 1);
					this.loadColorMapGradient();
					return true;
				});
		}

		private loadColorMapGradient():void {
			this.loadData(
				'image/color-map-gradient.png',
				new ImageFileHandler(),
				AssetLoaderEvent.COLOR_MAP_GRADIENT,
				(data:any):boolean => {
					this.colorMapGradient = new ColorMap();
					this.colorMapGradient.set(data, 1024, 1);
					this.loadPhotoTerrainTexture();
					return true;
				});
		}

		// pre-loading texture
		private loadPhotoTerrainTexture():void {
			if (Config.usePhotoTexture) {
				const photoTextureLoader = new PhotoTextureLoader();
				photoTextureLoader.addEventListener(PhotoTextureLoaderEvent.COMPLETE, this.photoTextureLoaderCompleteHandler);
				photoTextureLoader.addEventListener(PhotoTextureLoaderEvent.ERROR, this.photoTextureLoaderErrorHandler);
				photoTextureLoader.load();
			} else {
				this.loadUserImage();
			}
		}

		private photoTextureLoaderCompleteHandler = (event:PhotoTextureLoaderEvent):void => {
			this.photoTerrainTexture = event.getTexture();
			this.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.PHOTO_TERRAIN_TEXTURE, this));
			this.loadUserImage();
		};

		private photoTextureLoaderErrorHandler = (event:PhotoTextureLoaderEvent):void => {
			Sentry.getInstance().send('Load error (4xx) photo texture', SentryLevel.Warning);
			this.loadUserImage();
		};

		private loadUserImage():void {
			//if (Config.mode == Mode.Recording) {
				this.loadData(
					this.activity.getUserImageUrl(),
					new ImageFileHandler(),
					AssetLoaderEvent.USER_IMAGE,
					(data:any):boolean => {
						this.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.COMPLETE, this));
						return true;
					});
			//} else {
			//	this.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.COMPLETE, this));
			//}
		}





		private loadData(url:string, handler:IFileHandler, completeEventType:string, onComplete:(data:any) => boolean):void {
			if (Config.useProxy && url.indexOf('http') == 0 && this.isLocalhost) {
				url = './cache/proxy.php?q=' + encodeURIComponent(url);
			}
			trace('[AssetLoader] load :', url);
			this.loader = new FileLoader(1);
			this.loader.addHandler(handler);
			this.loader.require(url, handler.getType(), url);
			this.loader.addEventListener(FileLoaderSuccessEvent.SUCCESS, (event:FileLoaderSuccessEvent):void => {
				trace('[AssetLoader] load success : url = \'' + url + '\', info =', event.info);
				if (event.content) {
					const isAvailable = onComplete(event.content);
					if (isAvailable) {
						this.dispatchEvent(new AssetLoaderEvent(completeEventType, this));
					} else {
						trace('[AssetLoader] content is not available');
						Sentry.getInstance().send( + ', url = \'' + url + '\'', SentryLevel.Warning);
						this.showErrorMessage(url, this.getStatusCode(event.info.jqXHR), 'unavailable data');
					}
				} else {
					trace('[AssetLoader] content is null');
					Sentry.getInstance().send( + ', url = \'' + url + '\'', SentryLevel.Warning);
					this.showErrorMessage(url, this.getStatusCode(event.info.jqXHR), 'null data');
				}
			});
			this.loader.addEventListener(FileLoaderErrorEvent.ERROR, (event:FileLoaderErrorEvent):void => {
				trace('[AssetLoader] load error : url = \'' + url + '\', info =', event.info);
				this.showErrorMessage(url, this.getStatusCode(event.info.jqXHR));
			});
			this.loader.load();
		}





		private getStatusCode(jqXHR:any):number {
			return jqXHR ? jqXHR.status : -1;
		}

		private showErrorMessage(url:string, statusCode:number, sentryType:string = ''):void {
			let sentryMessage = ', status code = ' + statusCode + ', url = \'' + url + '\'';

			if (statusCode == 0) {
				// timeout / level = error
				Sentry.getInstance().send('Load error (timeout)' + sentryMessage, SentryLevel.Error);
				ErrorDialog.show(Config.errorTimeout, statusCode);

			} else if (statusCode == 200) {
				// unavailable data / level = warning
				Sentry.getInstance().send('Load error (' + sentryType + ')' + sentryMessage, SentryLevel.Warning);
				ErrorDialog.show(Config.errorTimeout, statusCode);

			} else if (statusCode === 401) {
				// 4xx / level = warning
				Sentry.getInstance().send('Load error (401)' + sentryMessage, SentryLevel.Warning);
				ErrorDialog.show(Config.errorNotAuthorized, statusCode);

			} else if (statusCode === 404) {
				// 4xx / level = warning
				Sentry.getInstance().send('Load error (404)' + sentryMessage, SentryLevel.Warning);
				ErrorDialog.show(Config.errorNotFound, statusCode);

			} else if (statusCode >= 400 && statusCode < 500) {
				// 4xx / level = warning
				Sentry.getInstance().send('Load error (4xx)' + sentryMessage, SentryLevel.Warning);
				ErrorDialog.show(Config.errorClientError, statusCode);

			} else if (statusCode >= 500 && statusCode < 600) {
				// 5xx / level = error
				Sentry.getInstance().send('Load error (5xx)' + sentryMessage, SentryLevel.Error);
				ErrorDialog.show(Config.errorServerError, statusCode);

			} else {
				// other issue / level = warning
				Sentry.getInstance().send('Load error (unknown)' + sentryMessage, SentryLevel.Warning);
				ErrorDialog.show(Config.errorGeneral, statusCode);
			}
		}





		public getActivityId():string {
			return this.activityId;
		}

		public getMeta():Meta {
			return this.meta;
		}

		public getTrack():Track {
			return this.track;
		}

		public getActivity():Activity {
			return this.activity;
		}

		public getDem():Dem {
			return this.dem;
		}

		public getColorMapElevation():ColorMap {
			return this.colorMapElevation;
		}

		public getColorMapGradient():ColorMap {
			return this.colorMapGradient;
		}

		public getUserImageUrl():HTMLImageElement {
			return this.userImage;
		}

		// pre-loading texture
		public getPhotoTerrainTexture():THREE.Texture {
			return this.photoTerrainTexture;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static getInstance():AssetLoader { return this.instance || (this.instance = new AssetLoader()) };
		private static instance:AssetLoader = null;

		private activityId:string;
		private token:string;
		private loader:FileLoader;
		private requestHeaders:any;

		private isLocalhost:boolean;
		private baseUrl:string;

		private meta:Meta;
		private activity:Activity;
		private dem:Dem;
		private track:Track;
		private colorMapElevation:ColorMap;
		private colorMapGradient:ColorMap;

		private userImage:HTMLImageElement;

		// pre-loading texture
		private photoTerrainTexture:THREE.Texture;
	}
}
